import React from 'react';
import { School } from 'lucide-react';

const DegreeDropdown = ({ degrees = [], value, onChange }) => {
    console.log("DegreeDropdown degrees:", degrees); // Add this to debug
    return (
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
          <School className="h-5 w-5 text-blue-600" />
        </div>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="pl-10 w-full rounded-lg border border-gray-300 bg-white py-2 text-gray-900 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
          required
        >
          <option value="">Select Degree</option>
          {Array.isArray(degrees) && degrees.map((degree) => (
            <option key={degree._id || degree.name} value={degree.name}>
              {degree.name}
            </option>
          ))}
        </select>
      </div>
    );
  };

export default DegreeDropdown;